<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view class="child-view" :key="$route.fullPath"></router-view>
      <!--      <router-view v-if="!$route.meta.keepAlive" class="child-view" :key="$route.fullPath"></router-view>-->
      <!--      <keep-alive :key="`${$route.fullPath}-keepAlive`">-->
      <!--        <router-view v-if="$route.meta.keepAlive" class="child-view" :key="`${$route.fullpath}-childView`"></router-view>-->
      <!--      </keep-alive>-->
    </transition>
  </div>
</template>

<script>
// import Alert from '@/components/share/alert'
import userService from './services/userService'
import kkUtil from './assets/js/kk-util'
import cookieUtil from './assets/js/cookie-util'

export default {
  name: 'App',
  data () {
    return {
      transitionName: 'right',
      isBack: false
    }
  },
  methods: {
    setBackStatus (event) {
      if (event.type === 'popstate') {
        this.$router.isBack = true
      }
    }
  },
  created () {
    let traceId = userService.getTraceId()
    let branchId = userService.getBranchId()
    let cookieKey = branchId + '_' + traceId
    let submited = cookieUtil.getCookie(cookieKey)
    if (!submited || submited === '') {
      userService.submitFromInfo()
      cookieUtil.setCookie(cookieKey, '1', 100)
    }
  },
  components: {
    // alert: Alert
  },
  mounted () {
    // window.addEventListener('popstate', this.setBackStatus, true);
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'book-read' && from.name === 'book-read') {
        this.transitionName = to.params.number > from.params.number ? 'right' : 'left'
      } else if (to.meta.type === 'none' && from.meta.type === 'none') {
        this.transitionName = 'none'
      } else if (to.meta.type === 'none' && from.meta.type === 'horizontal') {
        this.transitionName = 'left'
      } else if (to.meta.type === 'horizontal' && from.meta.type === 'none') {
        this.transitionName = 'right'
      } else if (to.meta.type === 'horizontal' && from.meta.type === 'horizontal') {
        this.transitionName = to.meta.number > from.meta.number ? 'right' : 'left'
      } else if (to.meta.type === 'vertical' && from.meta.type === 'vertical') {
        if (to.meta.number === from.meta.number) {
          this.transitionName = this.$router.isBack ? 'bottom-leave' : 'bottom-in'
        } else {
          this.transitionName = to.meta.number > from.meta.number ? 'bottom-in' : 'bottom-leave'
        }
      } else if ((to.meta.type === 'none' || to.meta.type === 'horizontal') && from.meta.type === 'vertical') {
        this.transitionName = 'bottom-leave'
      } else if (to.meta.type === 'vertical' && (from.meta.type === 'none' || from.meta.type === 'horizontal')) {
        this.transitionName = 'bottom-in'
      }
    }
  },
  beforeCreate () {
    let branchId = kkUtil.getQueryStr('fcid')
    if (branchId) {
      if (branchId.charAt(branchId.length - 1) == '/') {
        branchId = branchId.substring(0, branchId.length - 1)
      }
      userService.setBranchId(branchId)
    }
    this.clientType = kkUtil.getClientType()
    // let currRootUrl = window.location.protocol + "//" + window.location.host.replace('m.','p.');
    let currRootUrl = window.location.protocol + '//' + window.location.host
    if (this.clientType == 'pc') {
      let locationUrl = `${currRootUrl}/h5/pc?vueReturnUrl=${currRootUrl}`
      if (branchId) {
        locationUrl = locationUrl + '&fcid=' + branchId
      }
      window.location.href = locationUrl
    } else {
      if (kkUtil.inWechatAndQQ()) {
        let locationUrl = `${currRootUrl}/h5/wechat?vueReturnUrl=${currRootUrl}`
        if (branchId) {
          locationUrl = locationUrl + '&fcid=' + branchId
        }
        window.location.href = locationUrl
      }
    }
    userService.setUserFrom(kkUtil.getDomainFromUrl(document.referrer))
    let visitorId = kkUtil.getQueryStr('visitorId')
    if (visitorId) {
      if (visitorId.charAt(visitorId.length - 1) == '/') {
        visitorId = visitorId.substring(0, visitorId.length - 1)
      }
      userService.setTraceId(visitorId)
    }
  }
}
</script>

<style>

</style>

<style lang="less">
@import "assets/css/index.less";
</style>
